import { SET_TECHS } from './constants';

export const setTechs = (techs) => (
    {
        type: SET_TECHS,
        techs
    }
);